import React from "react";
import NotificationItem from "./NotificationItem";
import PaginationControls from "@/components/designer-grid/PaginationControls";
import { Notification } from "@/types/notification";
import { ContentPagination } from "@/v2/services/types/serviceInterfaces";

interface NotificationsListProps {
  notifications: Notification[];
  isLoading: boolean;
  pagination?: ContentPagination;
  onPageChange?: (page: number) => void;
  onNotificationAction?: (notification: Notification) => void;
}

const NotificationsList: React.FC<NotificationsListProps> = ({
  notifications,
  isLoading,
  pagination,
  onPageChange,
  onNotificationAction,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-gray-500">No notifications yet</p>
      </div>
    );
  }

  return (
    <div>
      <div className="divide-y">
        {notifications.map((notification) => (
          <NotificationItem 
            key={notification.id} 
            notification={notification}
            onActionClick={onNotificationAction ? () => onNotificationAction(notification) : undefined}
          />
        ))}
      </div>
      {pagination && pagination.totalPages > 1 && (
        <PaginationControls
          pagination={pagination}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default NotificationsList;
